document.addEventListener('DOMContentLoaded', function() {
	initLoginForm();
	initRegisterForm();
	initSearchForm();
	initCustomSelect(document.querySelectorAll('.custom-select'));
	initTabsFilter();
	initVideoBlock();
	initLibrary();
	initMenus();
	initLoadMore();
	initFormAutoSubmit();
}, false);

jQuery(document).ready(function() {
	initSliders();
});

jQuery(document).on('nfFormReady', (e) => {
	const elements = document.querySelectorAll('.nf-form-cont .listselect-wrap .nf-field-element');
	initCustomSelect(elements);
});

function initLoginForm() {
	const loginForm = document.getElementById('loginform');
	if (loginForm) {
		const usernameInput = loginForm.querySelector('input[name="log"]');
		const passwordInput = loginForm.querySelector('input[name="pwd"]');
		// Set required attribute to login form
		usernameInput.required = true;
		passwordInput.required = true;
		// Copy label to placeholder
		usernameInput.placeholder = usernameInput.previousElementSibling.textContent;
		passwordInput.placeholder = passwordInput.previousElementSibling.textContent;
	}
}

function initRegisterForm() {
	const registerForm = document.getElementById('registerform');
	if (registerForm) {
		const academySelector = registerForm.querySelector('select#academy');
		const academyUrl = academySelector.dataset.url;
		const academyNonce = academySelector.dataset.nonce;
		academySelector.addEventListener('change', function() {
			const academy = this.value;
			const ufaSelector = registerForm.querySelector('select#ufa');
			if(academy === '') {
				ufaSelector.innerHTML = '<option value="">- Sélectionnez une académie -</option>';
			} else {
				jQuery.get(academyUrl, { _ajax_nonce: academyNonce, action: "academy_get_ufa_options", academy: academy }, function (data) {
					const options = JSON.parse(data);
					if(options.length > 0) {
						ufaSelector.innerHTML = '';
						options.forEach(option => {
							const optionElement = document.createElement('option');
							optionElement.value = option.value;
							optionElement.textContent = option.text;
							ufaSelector.appendChild(optionElement);
							ufaSelector.dispatchEvent(new Event('change'));
						});
						initCustomSelect([ufaSelector.parentNode]);
					}
				});
			}
		});
		const jobSelector = registerForm.querySelector('select#job_parent');
		const jobUrl = jobSelector.dataset.url;
		const jobNonce = jobSelector.dataset.nonce;
		jobSelector.addEventListener('change', function() {
			const job = this.value;
			const functionSelector = registerForm.querySelector('select#job');
			if(job === '') {
				functionSelector.innerHTML = '<option value="">- Sélectionnez un métier -</option>';
			} else {
				jQuery.get(jobUrl, { _ajax_nonce: jobNonce, action: "job_get_function_options", job: job }, function (data) {
					const options = JSON.parse(data);
					if(options.length > 0) {
						functionSelector.innerHTML = '';
						options.forEach(option => {
							const optionElement = document.createElement('option');
							optionElement.value = option.value;
							optionElement.textContent = option.text;
							functionSelector.appendChild(optionElement);
							functionSelector.dispatchEvent(new Event('change'));
						});
						initCustomSelect([functionSelector.parentNode]);
					}
				});
			}
		});
	}
}

function initSearchForm() {
	const searchForms = document.querySelectorAll('form.search-form');
	searchForms.forEach(searchForm => {
		const input = searchForm.querySelector('input.search-field');
		['focus', 'click'].forEach(function(e) {
			input.addEventListener(e, function() {
				searchForm.classList.add('active');
			});
		});
		input.addEventListener('blur', function() {
			searchForm.classList.remove('active');
		});
	});
}

function initCustomSelect(elements) {
	var x, i, j, l, ll, selElmnt, a, b, c;
	x = elements;
	l = x.length;
	for (i = 0; i < l; i++) {
		const existing = x[i].querySelectorAll('.select-items, .select-selected');
		existing.forEach(el => {
			el.remove();
		});

		selElmnt = x[i].getElementsByTagName("select")[0];
		ll = selElmnt.length;
		/* For each element, create a new DIV that will act as the selected item: */
		a = document.createElement("DIV");
		a.setAttribute("class", "select-selected");
		a.innerHTML = selElmnt.options[selElmnt.selectedIndex].innerHTML;
		x[i].appendChild(a);
		/* For each element, create a new DIV that will contain the option list: */
		b = document.createElement("DIV");
		b.setAttribute("class", "select-items select-hide");
		for (j = 0; j < ll; j++) {
			/* For each option in the original select element,
			create a new DIV that will act as an option item: */
			c = document.createElement("DIV");
			c.innerHTML = selElmnt.options[j].innerHTML;
			// set "same-as-selected" class if value is selected
			if (selElmnt.options[j].getAttribute('selected') !== null) {
				c.setAttribute('class', 'same-as-selected');
			}
			c.addEventListener("click", function(e) {
				/* When an item is clicked, update the original select box,
				and the selected item: */
				var y, i, k, s, h, sl, yl;
				s = this.parentNode.parentNode.getElementsByTagName("select")[0];
				sl = s.length;
				h = this.parentNode.previousSibling;
				for (i = 0; i < sl; i++) {
					if (s.options[i].innerHTML == this.innerHTML) {
						s.selectedIndex = i;
						h.innerHTML = this.innerHTML;
						y = this.parentNode.getElementsByClassName("same-as-selected");
						yl = y.length;
						for (k = 0; k < yl; k++) {
							y[k].removeAttribute("class");
						}
						this.setAttribute("class", "same-as-selected");
						s.dispatchEvent(new Event('change'));
						break;
					}
				}
				h.click();
			});
			b.appendChild(c);
		}
		x[i].appendChild(b);
		a.addEventListener("click", function(e) {
			/* When the select box is clicked, close any other select boxes,
			and open/close the current select box: */
			e.stopPropagation();
			closeAllSelect(this);
			this.nextSibling.classList.toggle("select-hide");
			this.classList.toggle("select-arrow-active");
		});
	}

	function closeAllSelect(elmnt) {
		/* A function that will close all select boxes in the document,
		except the current select box: */
		var x, y, i, xl, yl, arrNo = [];
		x = document.getElementsByClassName("select-items");
		y = document.getElementsByClassName("select-selected");
		xl = x.length;
		yl = y.length;
		for (i = 0; i < yl; i++) {
			if (elmnt == y[i]) {
				arrNo.push(i)
			} else {
				y[i].classList.remove("select-arrow-active");
			}
		}
		for (i = 0; i < xl; i++) {
			if (arrNo.indexOf(i)) {
				x[i].classList.add("select-hide");
			}
		}
	}

	/* If the user clicks anywhere outside the select box,
	then close all select boxes: */
	document.addEventListener("click", closeAllSelect);
}

function initTabsFilter() {
	const tabs = document.querySelectorAll('.filter-tabs');
	if (tabs) {
		tabs.forEach(tab => {
			const tabItems = tab.querySelectorAll('.filter-tab a[href="#"]');
			tabItems.forEach(item => {
				item.addEventListener('click', function(e) {
					e.preventDefault();
					const id = this.dataset.tabId;
					const wrapper = this.closest('.tabs-filtered-content-wrapper');
					const tabContentItems = wrapper.querySelectorAll('.tabs-content-wrapper .tab-elmt');
					tabItems.forEach(item => {
						item.closest('.filter-tab').classList.remove('active');
					});
					tabContentItems.forEach(item => {
						item.classList.remove('active');
					});
					this.closest('.filter-tab').classList.add('active');
					// set active class on tabcontentitems with class tab-elmt-[tab ID]
					const activeTabContent = wrapper.querySelectorAll('.tabs-content-wrapper .tab-elmt-' + id);
					activeTabContent.forEach(item => {
						item.classList.add('active');
					});
				});
			});
		});
	}
}


function initVideoBlock() {
	const videoBlocks = document.querySelectorAll('.wp-block-video');
	videoBlocks.forEach(videoBlock => {
		const video = videoBlock.querySelector('video');
		if (video) {
			video.addEventListener('click', function() {
				video.setAttribute('controls', 'controls');
			});
			video.addEventListener('play', function() {
				video.setAttribute('controls', 'controls');
				videoBlock.classList.add('playing');
			});
			video.addEventListener('stop', function() {
				video.removeAttribute('controls');
				videoBlock.classList.remove('playing');
				video.load();
			});
			video.addEventListener('ended', function() {
				video.removeAttribute('controls');
				videoBlock.classList.remove('playing');
				video.load();
			});
		}
	});
}

function initSliders() {
	if ( typeof jQuery.fn.slick === 'function' ) {
		const sliders = document.querySelectorAll('.slick-slider:not(.slick-initialized):not(.slick-mobile-only)');
		sliders.forEach(slider => {
			const params = slider.dataset.slick;
			const defaultParams = {
				infinite: true,
				slidesToScroll: 1,
				slidesToShow: 1,
			};
			jQuery(slider).slick(Object.assign(defaultParams, params));
		});

		window.addEventListener('resize', function() {
			if(isBreakPoint('md')) {
				initMobileSliders();
			} else {
				removeMobileSliders();
			}
		});
		if(isBreakPoint('md')) {
			initMobileSliders();
		}
	}
}

function initMobileSliders() {
	const sliders = document.querySelectorAll('.slick-slider:not(.slick-initialized).slick-mobile-only');
	sliders.forEach(slider => {
		const params = slider.dataset.slick;
		console.log(params);
		const defaultParams = {
			infinite: true,
			slidesToScroll: 1,
			slidesToShow: 1,
		};
		jQuery(slider).slick(Object.assign(defaultParams, params));
	});
}

function removeMobileSliders() {
	const sliders = document.querySelectorAll('.slick-slider.slick-mobile-only.slick-initialized');
	sliders.forEach(slider => {
		jQuery(slider).slick('unslick');
		slider.classList.add('slick-slider');
	});

}


function initLibrary() {
	loadLibrary();

	const wrapper = document.querySelector('.gdrive_library_wrapper');
	if(!wrapper) {
		return;
	}
	let linkClicked = false;
	wrapper.addEventListener('click', function(e) {
		if(e.target.classList.contains('directory-link')) {
			e.preventDefault();
			if (!linkClicked) {
				loadLibrary(e.target.dataset.directoryId);
				linkClicked = true;
				setTimeout(() => linkClicked = false, 1000);
			}
		}
	});
}

function loadLibrary(directoryId = null) {
	const wrapper = document.querySelector('.gdrive_library_wrapper');
	if(!wrapper) {
		return;
	}

	let rootDirectories;
	if(directoryId) {
		rootDirectories = [directoryId];
	} else {
		rootDirectories = wrapper.dataset.dirs.split(',');
	}

	if(rootDirectories.length <= 0) {
		return;
	}

	const url = wrapper.dataset.url;
	const nonce = wrapper.dataset.nonce;

	jQuery.get(url, { _ajax_nonce: nonce, action: "library_get_directory_content", directory: rootDirectories }, function (data) {
		const pathContent = wrapper.querySelector('.path .content');
		const directoriesWrapper = wrapper.querySelector('.directories');
		const filesWrapper = wrapper.querySelector('.files');
		const directoriesContent = directoriesWrapper.querySelector('.content');
		const filesContent = filesWrapper.querySelector('.content');
		pathContent.innerHTML = '';
		directoriesContent.innerHTML = '';
		filesContent.innerHTML = '';
		if(data.directories && data.directories.length > 0) {
			directoriesWrapper.classList.remove('d-none');
			data.directories.forEach(directory => {
				const elementWrapper = document.createElement('div');
				elementWrapper.classList.add('element-wrapper', 'col-sm-6', 'col-md-4', 'col-lg-3', 'col-xl-2', 'mb-4');
				const link = document.createElement('a');
				link.href = '#';
				link.dataset.directoryId = directory.id;
				link.textContent = directory.name;
				link.classList.add('directory-link');
				elementWrapper.appendChild(link);
				directoriesContent.appendChild(elementWrapper);
			});
		} else {
			directoriesWrapper.classList.add('d-none');
		}
		if(data.files && data.files.length > 0) {
			filesWrapper.classList.remove('d-none');
			data.files.forEach(file => {
				const elementWrapper = document.createElement('div');
				elementWrapper.classList.add('element-wrapper', 'col-sm-6', 'col-md-4', 'col-lg-3', 'col-xl-2', 'mb-4');

				const img = document.createElement('img');
				img.src = file.thumbnailLink;

				const imgWrapper = document.createElement('div');
				imgWrapper.classList.add('thumbnail-wrapper');
				imgWrapper.appendChild(img);

				const icon = document.createElement('img');
				icon.src = '//drive-thirdparty.googleusercontent.com/16/type/' + file.mimeType;
				icon.classList.add('icon');
				const link = document.createElement('a');
				link.href = file.webViewLink;
				link.target = '_blank';

				const titleWrapper = document.createElement('div');
				titleWrapper.classList.add('title-wrapper');
				link.appendChild(titleWrapper);

				titleWrapper.appendChild(icon);
				const title = document.createElement('span');
				title.textContent = file.name;
				titleWrapper.appendChild(title);

				link.appendChild(imgWrapper);

				elementWrapper.appendChild(link);
				filesContent.appendChild(elementWrapper);
			});
		} else {
			filesWrapper.classList.add('d-none');
		}

		const currentBaseUrl = window.location.href.split('?')[0];
		const pathElements = [];
		if(data.current) {
			pathElements.push('<a href="' + currentBaseUrl + '">Bibliothèque</a>');
		} else {
			pathElements.push('<span>Bibliothèque</span>');
		}

		if(data.parents) {
			data.parents.forEach(parent => {
				pathElements.push('<a href="#" class="directory-link" data-directory-id="' + parent.id + '">' + parent.name + '</a>');
			});
		}

		if(data.current) {
			pathElements.push('<span>' + data.current[0].name + '</span>');
		}

		pathContent.innerHTML = pathElements.join(' > ');
	});
}

function initMenus() {
	const menus = document.querySelectorAll('.menu');
	menus.forEach(menu => {
		const items = menu.querySelectorAll('.menu-item');
		items.forEach(item => {
			const link = item.querySelector('a');
			const submenu = item.querySelector('.sub-menu');
			if(link && link.getAttribute('href') === '#' && submenu) {
				link.addEventListener('click', function(e) {
					e.preventDefault();
					submenu.classList.toggle('active');
				});
			}
		});
	});

	const burgerMenus = document.querySelectorAll('.burger-menu');
	burgerMenus.forEach(burgerMenu => {
		burgerMenu.addEventListener('click', function() {
			const menu = document.querySelector('.sidebar-wrapper');
			menu.classList.toggle('active');
			if(menu.classList.contains('active')) {
				burgerMenu.classList.add('active');
			} else {
				burgerMenu.classList.remove('active');
			}
		});
	});

}

function initLoadMore() {
	let currentPage = 1;
	const loadMoreButtons = document.querySelectorAll('.load-more');
	loadMoreButtons.forEach(loadMoreButton => {
		const queryInfo = loadMoreButton.dataset.queryInfo;
		loadMoreButton.addEventListener('click', function(e) {
			e.preventDefault();
			if(queryInfo === 'index') {
				const button = this;
				const data = {
					'action' : 'index_loadmore',
					'query': index_loadmore_params.posts,
					'page' : currentPage
				}
				jQuery.ajax({
					url : index_loadmore_params.ajaxurl,
					data : data,
					type : 'POST',
					success : function( data ){
						if( data ) {
							currentPage++;
							const loadMoreResults = document.querySelector('.load-more-results');
							loadMoreResults.innerHTML += data;

							if ( currentPage == index_loadmore_params.max_page ) {
								button.remove();
							}
						} else {
							button.remove();
						}
					}
				})
			} else {
				jQuery.ajax({
					type: 'POST',
					url: '/wp-admin/admin-ajax.php',
					dataType: 'html',
					data: {
						action: 'cerfal_query_load_more',
						paged: currentPage,
						queryInfo: queryInfo,
					},
					success: function (json) {
						currentPage++;
						const res = JSON.parse(json);
						const loadMoreResults = document.querySelector('.load-more-results');
						loadMoreResults.innerHTML += res.output;
						if(res.more_results === false) {
							loadMoreButton.remove();
						}
					}
				});
			}
		});
	});
}

function isBreakPoint(size, direction= 'max') {
	var value = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-' + size);
	return window.matchMedia("(" + direction + "-width: "+ value +")").matches;
}

function initFormAutoSubmit() {
	// auto submit form when select change and text field change after blur
	const form = document.querySelector('form.auto-submit');
	if(!form) {
		return;
	}
	const selects = form.querySelectorAll('select');
	const textFields = form.querySelectorAll('input[type="text"]');
	selects.forEach(select => {
		select.addEventListener('change', function() {
			form.submit();
		});
	});
	textFields.forEach(textField => {
		textField.addEventListener('blur', function() {
			form.submit();
		});
	});
	// jQuery(document).on('click', '.form-filter .reset', function(e) {
	// 	e.preventDefault();
	// 	const form = this.closest('form');
	// 	form.reset();
	// 	form.submit();
	// });
}